<template>
  <section class="rich-text">
    <BaseRichText class="text" :content="content.content" />
  </section>
</template>
<script setup lang="ts">
const props = defineProps({
  content: {
    type: Object,
    required: true,
    default() {
      return {};
    },
  },
});
</script>
<style scoped lang="scss">
.rich-text {
  @apply py-10 w-full max-md:px-5 max-md:max-w-full;

  .text {
    :deep() {
      p {
        @apply text-sm;
      }
      h2 {
        @apply text-4xl font-semibold text-primary;
      }
    }
  }
}
</style>
